<template >
  <div class="ReviewRoom" v-if="show" :class="{ loading: loading > 0 }">
    <h2 class="title">{{ tran("REVIEW_ROOM_TITLE") }}</h2>
    <div class="review-rooms" v-if="items">
      <div class="review-room" v-for="(item, index) in items" :key="index">
        <div class="wrapper">
          <div class="image">
            <img v-if="item.image" :src="item.image" />
          </div>
          <div>
            <div
              class="desc"
              :style="'background-image:url(' + item.image + ')'"
            >
              <h3 class="title" v-html="item.title"></h3>
              <p class="price" v-html="item.location"></p>
              <div class="description" v-html="item.description"></div>
            </div>
            <div class="total-detail">
              <div v-html="item.detail"></div>
              <div v-if="userRooms.length == 1" class="buttons">
                <button
                  id="room-confirm"
                  type="button"
                  class="btn btn-success"
                  @click.prevent="holdCabins"
                >
                  {{ tran("LOCK_IT_IN") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="review-footer" v-if="userRooms.length > 1">
      <div class="total-detail"><div v-html="total"></div></div>
      <div class="buttons">
        <button
          id="room-confirm"
          type="button"
          class="btn btn-success"
          @click.prevent="holdCabins"
        >
          {{ tran("LOCK_IT_IN") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReviewRoom",
  components: {},
  props: {
    run: Function,
  },
  data: function () {
    return {
      loading: 0,
      items: false,
      total: "",
    };
  },
  created() {
    window.showCancellationFees = this.showCancellationFees.bind(this);
  },
  mounted: function () {
    this.run("set", "groupStep." + this.$.type.name, "review_pay");
    if (typeof this.validate == "function") {
      this.run("set", "validates." + this.$.type.name, this.validate);
    }
    if (typeof this.next == "function") {
      this.run("set", "nexts." + this.$.type.name, this.next);
    }
    if (typeof this.prev == "function") {
      this.run("set", "prevs." + this.$.type.name, this.prev);
    }
    if (this.show) {
      this.onShow();
    }
  },
  watch: {
    show: function (n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
  },

  computed: {
    show: function () {
      return this.run("currentStep") == this.$.type.name;
    },
    data() {
      return this.run("get", "data");
    },
    currentUserRoomIndex() {
      return this.run("get", "currentUserRoomIndex");
    },
    userRooms() {
      return this.run("get", "rooms");
    },

    nextRoomIndex() {
      let nextRoomIndex = this.userRooms.length;
      for (const roomIndex in this.userRooms) {
        const room = this.userRooms[roomIndex];
        if (
          !room.userChooseRoom ||
          !room.roomNumber ||
          !room.category ||
          !room.categoryType
        ) {
          nextRoomIndex = roomIndex;
        }
      }
      if (this.currentUserRoomIndex > nextRoomIndex) {
        return nextRoomIndex;
      }
      if (this.currentUserRoomIndex < this.userRooms.length - 1) {
        return this.currentUserRoomIndex + 1;
      }
      return -1;
    },
  },
  methods: {
    tran: function (key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow: function () {
      // for (const roomIndex in this.userRooms) {
      //   const fareCode = this.run(
      //     "get",
      //     "rooms." + roomIndex + ".fareCode",
      //     false
      //   );
      //   if (!fareCode) {
      //     this.run("goStep", this.run("stepIndex", "RoomCategory"));
      //     return;
      //   }
      // }
      this.fetch();
    },
    onHide: function () {},
    async fetch() {
      this.loading++;
      const rooms = this.run("rooms");
      const numberOfRoom = this.run("numberOfRoom");
      const promotionCode = this.run("promotionCode");
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task="+(this.run('get', 'config.task', "booking"))+".getReviewRooms",
        { rooms, numberOfRoom, promotionCode }
      );
      if (!res.success) {
        this.run("showMessage", res.message ?? "error", res.messageType);
        this.loading--;
        return;
      }
      this.items = res.data.items;
      this.total = res.data.total;

      this.loading--;
    },
    async holdCabins(holdOnly) {
      this.loading++;
      const rooms = this.run("rooms");
      const ship = this.run("ship");
      // const numberOfRoom = this.run("numberOfRoom");
      // const promotionCode = this.run("promotionCode");
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task="+(this.run('get', 'config.task', "booking"))+".cabinHold",
        {
          rooms,
          shipCode: ship.shipCode,
          packageId: ship.packageId,
          sailDate: ship.sailDate,
        }
      );
      if (res.data && res.data.rooms) {
        this.run("set", "rooms", res.data.rooms);
      }
      if (res.success) {
        holdOnly !== true && this.run("next");
        this.loading--;
        return true;
      }
      this.run("showMessage", res.message ?? "error", res.messageType);
      setTimeout(
        () => this.run("goStep", this.run("stepIndex", "RoomChoose")),
        200
      );

      this.loading--;
      return false;
    },
    showCancellationFees(index) {
      this.run("modal", this.items[index].fees, "cancellation-fees");
    },
    async validate() {
      this.run("showLoading");
      const rs = await this.holdCabins(true);
      this.run("hideLoading");
      return rs;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
